import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStrapiComponent } from './simple-icons-strapi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStrapiComponent ],
    exports:      [ SimpleIconsStrapiComponent ],
    bootstrap:    []
})
export class SimpleIconsStrapiModule {}
